var irreducible = require('./irreducible');
var isNumber = require('./isNumber');

module.exports = irreducible('Number', isNumber);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Number.js
 ** module id = 496
 ** module chunks = 1
 **/